import { render, staticRenderFns } from "./CitationAudit.vue?vue&type=template&id=48e11f1e"
import script from "./CitationAudit.vue?vue&type=script&lang=js"
export * from "./CitationAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports